const BASE_SELECTOR: string = '[data-permissions]';
const DELETE_BUTTON_SELECTOR: string = '[data-delete]';
const tableRowTemplate = require('./view/table_row.handlebars');

export class PermissionsUI {
  public constructor(private $base: JQuery) {

  }

  public onFormSubmit(callback: () => {}) {
    this.$base.on('submit', (e) => {
      e.preventDefault();
      callback();
    });
  }

  public onDeleteButtonClick(callback: (id: number) => {}) {
    this.$base.find(DELETE_BUTTON_SELECTOR).off('click');
    this.$base.find(DELETE_BUTTON_SELECTOR).on('click', function (e) {
      const id = $(this).data('delete');
      e.preventDefault();
      callback(id);
    });
  }

  public render(data) {
    this.$base.find('.table__content .table__row').remove();
    this.$base.find('.table__content').prepend(tableRowTemplate({data: data}));
  }

  public clearInput() {
    this.$base.find('input').val('');
  }

  public getUsername() {
    return this.$base.find('input').val();
  }
}

export function createPermissionInstances() : PermissionsUI[] {
  const instances: PermissionsUI[] = [];
  $(BASE_SELECTOR).each((index, element) => {
    instances.push(new PermissionsUI($(element)));
  });

  return instances;
}
